/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import ActionItem from './ActionItem';
import { useActionListContext } from '../context';
import { Action } from '../types';

type Props = Action;

const ActionItemContainer = (action: Props) => {
  const { status, error, action: fn, index } = action;
  const { currentIndex, next, retryRequested, setCurrent } =
    useActionListContext();

  // Update the context's status/error/etc whenever it changes
  useEffect(() => {
    if (currentIndex === index) {
      setCurrent(action);
    }
  }, [currentIndex, status, error]);

  // Trigger this action item when its index gets set
  useEffect(() => {
    if (currentIndex === index && status !== 'Success') {
      fn();
    }
  }, [currentIndex]);

  // If the action item has completed, move on to the next one
  useEffect(() => {
    if (currentIndex === index && status === 'Success') {
      next();
    }
  }, [status, currentIndex]);

  // Trigger a retry if the user has clicked on the top level retry button
  useEffect(() => {
    if (retryRequested && currentIndex === index) {
      fn();
    }
  }, [retryRequested]);

  return <ActionItem {...action} />;
};

export default ActionItemContainer;
